export default "__VITE_ASSET__1DZCX2Sy__"